<script setup>
import { computed } from 'vue'

const props = defineProps({
  paginator: {
    type: Object,
    default: () => ({ total: 0, rows: 10, page: 1 })
  }
})

const total = computed(() => props.paginator.total)
const rows = computed(() => props.paginator.rows)
const page = computed(() => props.paginator.page)
const first = computed(() => (page.value - 1) * rows.value)

const emit = defineEmits(['pageChanged'])

function handlePageChange(event) {
  const newPage = Math.floor(event.first / event.rows) + 1
  emit('pageChanged', newPage)
}
</script>

<template>
  <!--
    data-list-top: początek listy, cel przewijania po zmianie strony.
    Filtry stoją NAD paginatorem i na wąskim ekranie renderują się po jednym
    w wierszu, więc potrafią zająć cały ekran. Przewijanie na szczyt kontenera
    lądowałoby wtedy na filtrach, a po kliknięciu paginacji użytkownik chce
    zobaczyć kolejne pozycje, nie zmieniać filtry.
  -->
  <div data-list-top>
    <slot />
  </div>
  <div v-if="total && rows">
    <pv-paginator
      :first="first"
      :rows="rows"
      :totalRecords="total"
      @page="handlePageChange"
    />
  </div>
</template>
